export type MenuItem = {
	key: string;
	label: string;
	mobileLabel: string;
};

export function getMenuItems(isLoggedIn: boolean, isMerchant: boolean): MenuItem[] {
	const menuItems: MenuItem[] = [];

	if (!isLoggedIn) {
		return [];
	}

	menuItems.push(
		{ key: 'my-orders', label: 'myOrders', mobileLabel: 'navMyOrders' },
		{ key: 'merchants', label: 'merchants', mobileLabel: 'navMerchants' },
		{ key: 'wallet', label: 'WALLET', mobileLabel: 'navWallet' },
	);

	if (isMerchant) {
		menuItems.push({ key: 'my-offers', label: 'myOffers', mobileLabel: 'navMyOffers' });
	}

	menuItems.push({ key: 'terms-condition', label: 'termsAndConditions', mobileLabel: 'navTermsAndConditions' });

	return menuItems;
}
